import { useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import metricsServices from '@/metrics/services/services'

import { transformResponsePerformanceInsightsEarnings } from './transformers'

const usePerformanceInsightsEarnings = ({ storeId, startDate, endDate }) => {
  const [settledRequest, setSettledRequest] = useState()

  const { data, loading, fetchDataCancellable } = useFetch(metricsServices.getPerformanceInsightsEarnings, {
    doInitialRequest: false,
    transformResponse: transformResponsePerformanceInsightsEarnings,
  })

  const requestKey = `${storeId}-${startDate}-${endDate}`
  const isRequestSettled = settledRequest?.key === requestKey

  const refetchWhenArgsChange = () => {
    const params = { start_date: startDate, end_date: endDate }

    fetchDataCancellable(
      { storeId, params },
      () => setSettledRequest({ key: requestKey, hasError: false }),
      () => setSettledRequest({ key: requestKey, hasError: true })
    )
  }

  useEffect(refetchWhenArgsChange, [endDate, fetchDataCancellable, requestKey, startDate, storeId])

  return {
    earnings: data,
    fetchingEarnings: loading || !isRequestSettled,
    earningsError: isRequestSettled && settledRequest.hasError,
  }
}

export default usePerformanceInsightsEarnings
